/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/Legend.scss';

class Legend extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
  };

  renderText = () => {
    const { text } = this.props;
    if (!text) {
      return null;
    }
    return text;
  };

  render() {
    return (
      <legend
        className={cx(
          'Legend',
          this.props.className
        )}>
        {this.renderText()}
        {this.props.children}
      </legend>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/Legend.jsx